import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import KingBedOutlinedIcon from "@mui/icons-material/KingBedOutlined";
import ChairOutlinedIcon from "@mui/icons-material/ChairOutlined";
import Filter from "../Filter/Filter";
import Headerimage from "../Headerimage/Headerimage";
import Divider from "../Divider/Divider";
import Popup from "../Popup/Popup";
import "./Header.css";

const Header = () => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [activeLink, setActiveLink] = useState(null);
  const { t } = useTranslation();

  const handlePopupToggle = () => {
    setIsPopupVisible(!isPopupVisible);
  };

  const handleLinkClick = (link) => {
    setActiveLink(link);
  };

  const updateActiveLinkFromPath = () => {
    const urlPath = window.location.pathname;
    setActiveLink(urlPath === "/" ? "/" : urlPath);
  };

  useEffect(() => {
    updateActiveLinkFromPath();
  }, []);

  return (
    <header className="header">
      {/* Divider Section */}
      <section id="divider">
        <Divider backgroundcolor="var(--secondary-color)" height="auto">
          <nav className="nav">
            <ul>
              <li>
                <a
                  href="/"
                  className={`nav-link ${activeLink === "/" ? "active" : ""}`}
                  onClick={() => handleLinkClick("/")}
                >
                  {t("home")}
                </a>
              </li>
              <li>
                <a
                  href="/activiteiten"
                  className={`nav-link ${
                    activeLink === "/activiteiten" ? "active" : ""
                  }`}
                  onClick={() => handleLinkClick("/activiteiten")}
                >
                  {t("bezienswaardigheden")}
                </a>
              </li>
              <li>
                <a
                  href="https://www.servimoholidays.be/nl/accommodatie/711/Tijl-0801"
                  className={`nav-link ${
                    activeLink === "/boekhier" ? "active" : ""
                  }`}
                  onClick={() => handleLinkClick("/boekhier")}
                >
                  {t("boekHier")}
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className={`nav-link ${
                    activeLink === "/contact" ? "active" : ""
                  }`}
                  onClick={() => handleLinkClick("/contact")}
                >
                  {t("contact")}
                </a>
              </li>
            </ul>
          </nav>
        </Divider>
      </section>
      <Filter
        children={
          <Headerimage bgimg="assets/Images/SeeLine.jpg">
            <div className="headertextblock">
              <h1 className="headertitle">TIJL 0801</h1>
              <p className="afterMui">
                <span className="afterMuielement">
                  <PersonOutlineOutlinedIcon /> Max. 4 |{" "}
                </span>
                <span className="afterMuielement">
                  <KingBedOutlinedIcon /> 1 Bed |{" "}
                </span>
                <span className="afterMuielement">
                  <ChairOutlinedIcon /> 1 {t("zetelbed")}
                </span>
              </p>
            </div>
          </Headerimage>
        }
        backgroundcolor="rgba(0, 0, 0, 0.1)"
      />
      {/* Divider Section */}
      <section id="divider">
        <Divider backgroundcolor="var(--secondary-color)" height="40px">
          <p className="adress" onClick={handlePopupToggle}>
            <p className="afterMui link">
              <PlaceOutlinedIcon /> Zeedijk 27 bus 0801, 8620 Nieuwpoort
            </p>
          </p>
        </Divider>
      </section>

      {isPopupVisible && (
        <Popup onClose={handlePopupToggle}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5937.648445398512!2d2.713526676862025!3d51.148912236828345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47dca32ac4113741%3A0xda2ca054c062bfc1!2sZeedijk%2027%2C%208620%20Nieuwpoort!5e1!3m2!1snl!2sbe!4v1735397609310!5m2!1snl!2sbe"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            width="100%"
            height="100%"
            title="Google Maps Tijl 801"
          ></iframe>
        </Popup>
      )}
    </header>
  );
};

export default Header;
